import {
  ChartBuilder
} from './chart-builder';
import 'echarts/build/echarts-all.js';

import {
  Measure
} from '../common/measure';

import {
  hoursToTime,
  ticksFormat,
  ticksToHours
} from '../common/datetime';

// import echarts from 'echarts/lib/echarts'
// import 'echarts/lib/chart/bar';
// import 'echarts/lib/chart/line';

/*@ngInject*/

const maxXDataStingLenght = 77;
const oneCharacterWidth = 6;

class ChartController {
  constructor(
    $scope,
    $element,
    RouterService,
    LayoutService,
    $rootScope,
    rx,
  ) {
    this.theme = $rootScope.theme;
    this.$scope = $scope;
    this.$element = $element;
    this.router = RouterService;
    this.currentFilter = this.router.CurrentFilterService.filter;
    this.LayoutService = LayoutService;
    this.container = null;
    this.chart = null;
    this.chartType = 'bar';
    this.LayoutService.drilldownMax = 2;
    this.chartAreaIsStacked = true;
    this.minHeight = 1;
    this.minWidth = 1;
    this.renderDebounce = 100;
    this.aggregate = null;
    this.filter = null;
    this.bytesToHuman = Measure.bytesToHuman;

    const subscriptions = [
      rx.Observable.merge(
        $scope.$eventToObservable('resizeBeforePrint'),
        rx.Observable.merge(
          $scope.$eventToObservable('dashboardResize'),
          $scope.$eventToObservable('resize'),
          $scope.$eventToObservable('splitter1Changed'),
        ).debounce(100))
      .subscribe(() => {
        this.resize();
      }),
      rx.Observable.merge(
        rx.Observable.merge(
          $scope.$toObservable('$ctrl.filter.orders'),
          $scope.$toObservable('$ctrl.filter.orderDirs'),
          $scope.$toObservable('$ctrl.aggregate'),
        ).debounce(this.renderDebounce),
        // $scope.$eventToObservable('beforePrint'),
        // $scope.$eventToObservable('afterPrint'),
        // $scope.$eventToObservable('init'),
      )
      .subscribe((e) => {
        this.render(e);
      }),
    ];
    $scope.$on('$destroy', () => {
      subscriptions.forEach((subscription) => {
        subscription.dispose();
      });
    });
  }

  labelRotate(len) {
    const w = this.container.clientWidth / len;
    const d = 20;
    if (d > w) return -90;
    if (w >= this.xDataWidth) return 0;
    return -Math.asin(d / w) * 180 / Math.PI;
  }

  gridHeight(len) {
    const h = this.xDataWidth * Math.abs(Math.sin(Math.PI / 180 * this.labelRotate(len)));
    return this.container.clientHeight - h - 120;
  }

  get isPrint() {
    return this.router.pdf || this.LayoutService.isPrint;
  }

  resize() {
    if (this.chart.chart.bar) this.chart.chart.bar.option.animation = !this.isPrint;
    if (this.chart && this.$element.height() > this.minHeight &&
      this.$element.width() > this.minWidth) {
      this.chart._option.xAxis[0].axisLabel.rotate = this.labelRotate(
        this.chart.getOption().xAxis[0].data.length);
      this.chart._option.grid.height = this.gridHeight(
        this.chart.getOption().xAxis[0].data.length);
      this.chart.resize();
    }
  }

  render(e) {
    if (!this.aggregate || !this.filter) {
      return;
    }

    if (this.$element.height() <= this.minHeight ||
      this.$element.width() <= this.minWidth) {
      return;
    }

    const builder = new ChartBuilder(
      this.aggregate,
      this.filter,
      this.filter.chartAreaType,
      this.filter.chartAreaIsStacked === undefined ? true : this.filter.chartAreaIsStacked,
      this.model,
    );
    builder.build();

    let maxLen = 0;
    builder.xData = builder.xData.map(d => {
      let s = String(d);
      const l = s.length;
      if (l > maxXDataStingLenght) {
        s = `${s.substr(0, maxXDataStingLenght)}...`;
      }
      if (s.length > maxLen) maxLen = s.length;
      return s;
    });
    this.xDataWidth = maxLen * oneCharacterWidth;

    // const axisLabelFormatter = this.filter.measure === 'activity_time_sum' ?
    //   value => hoursToTime(value) :
    //   value => value;

    let axisLabelFormatter = value => value;
    if (this.filter.measure === 'activity_time_sum') {
      axisLabelFormatter = value => hoursToTime(value);
    } else if (this.filter.measure === 'file_size_sum') {
      axisLabelFormatter = value => this.bytesToHuman(value);
    }

    this.container = this.$element[0];
    this.chart = echarts.init(this.container);

    const options = {
      // animation: e.name !== 'beforePrint' && e.name !== 'resizeBeforePrint',
      tooltip: {
        trigger: 'item',
        formatter: this.filter.measure === 'activity_time_sum' ?
          (params) => {
            return params.name + '<br/>' +
              ticksFormat(params.value * ticksToHours);
          } : null,
      },
      toolbox: {
        show: !this.isPrint,
        feature: {
          magicType: {
            show: true,
            type: ['bar', 'line', 'tiled', 'stack', ],
            title: {
              bar: gettext('Гистограмма'),
              line: gettext('Линейный График'),
              tiled: gettext('Без накопления'),
              stack: gettext('С накоплением'),
            },
          },
          // restore: {show: true},
          saveAsImage: {
            show: true,
            title: gettext('Сохранить'),
            lang: [gettext('Нажмите кнопку [Сохранить]')],
          },
        },
      },
      noDataLoadingOption: {
        text: gettext(
          'Нет данных.\nВыберите пользователей, либо измените параметры фильтра.'),
        effect: 'bubble',
      },
      // calculable : true,
      dataZoom: {
        show: !this.isPrint,
        realtime: true,
        start: 0,
        end: 100,
      },
      legend: {
        // type: 'scroll',
        show: true,
        data: builder.legendData,
        display: true,
        y: 25,
        orient: 'horizontal',
        textStyle: {
          fontFamily: 'arial', // 'sans-serif',
          fontSize: 10,
          fontWeight: 'lighter',
          color: this.theme == 'dark' ? '#eee' : '#333'
        },
      },
      grid: {
        height: this.gridHeight(builder.xData.length),
        color: this.theme == 'dark' ? '#eee' : '#333',
      },
      xAxis: [{
        type: 'category',
        axisLabel: {
          show: true,
          interval: 0,
          rotate: this.labelRotate(builder.xData.length),
          textStyle: {
            color: this.theme == 'dark' ? '#eee' : '#333'
          },
        },
        data: builder.xData,
      }, ],
      yAxis: [{
        type: 'value',
        splitArea: {
          show: true
        },
        axisLabel: {
          formatter: axisLabelFormatter,
          textStyle: {
            color: this.theme == 'dark' ? '#eee' : '#333'
          },
        },
      }, ],
      series: builder.yData,
      animation: !this.isPrint,
      addDataAnimation: !this.isPrint,
    };
    if (this.theme == 'dark') {
      options.toolbox.feature.magicType.color = '#99f0ff';
    }
    this.chart.setOption(options);
    this.chart.on('magicTypeChanged', (e) => {
      const magicType = e.magicType;

      if (magicType.bar) {
        // if (this.router.isFilterEditModal)
        this.filter.chartAreaType = 'bar';
        // else
        // this.router.chartAreaType = 'bar';
      }
      if (magicType.line) {
        // if (this.router.isFilterEditModal)
        this.filter.chartAreaType = 'line';
        // else this.router.chartAreaType = 'line';
      }
      // if (this.router.isFilterEditModal)
      this.filter.chartAreaIsStacked = !!e.magicType.stack;
      // else this.router.chartAreaIsStacked = !!e.magicType.stack;

      if (this.router.isFilterEditModal) this.filterData.update(this.filter);
      else {
        this.router.filter = this.filter;
        this.$scope.$root.$digest();
      }
    });

    this.chart.on('click', (e) => {
      if (!this.filter.drilldown.length) return;

      const cuts = [builder.filterValues.find(fv => fv.label === e.name)];
      if (this.filter.drilldown.length > 1) {
        const filterValue = builder.filterYValues[e.seriesIndex];
        cuts.push(filterValue);
      }
      this.router.drilldownCuts(cuts);
      this.$scope.$root.$digest();
    });
    this.chart.resize();
  }
}

export const ChartComponent = {
  template: require('./chart.component.html'),
  bindings: {
    model: '<',
    aggregate: '<',
    filter: '<',
    filterData: '<',
  },

  controller: ChartController,
};



// WEBPACK FOOTER //
// ./src/stat/chart.component.js